import { render, staticRenderFns } from "./DispatchList.vue?vue&type=template&id=ba0432f0&scoped=true"
import script from "./DispatchList.vue?vue&type=script&lang=ts"
export * from "./DispatchList.vue?vue&type=script&lang=ts"
import style0 from "./DispatchList.vue?vue&type=style&index=0&id=ba0432f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0432f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba0432f0')) {
      api.createRecord('ba0432f0', component.options)
    } else {
      api.reload('ba0432f0', component.options)
    }
    module.hot.accept("./DispatchList.vue?vue&type=template&id=ba0432f0&scoped=true", function () {
      api.rerender('ba0432f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/components/DispatchList.vue"
export default component.exports